// extracted by mini-css-extract-plugin
export var aircallIframe = "_lw-3";
export var fabContainer = "_lw-5";
export var fabRinging = "_lw-6";
export var loadingOverlay = "_lw-4";
export var pulse = "_lw-7";
export var widgetContent = "_lw-2";
export var widgetPanel = "_lw-0";
export var widgetPanelExpanded = "_lw-1";